import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'

import StackGrid from "react-stack-grid";

import { Card } from '../../../common/index';

import classes from './MarksCards.module.scss';


class MarksCards extends Component {
    
    render() {
        return(
          <div className={classes.Container}>
            { this.props.marks.map((markitem)=>{ return(
             <Card className="classes.Card" onClick={()=>this.props.history.push(`/marks/${markitem.id}`)} key={markitem.id} image={markitem.image} withfavorite isfavorite={ this.props.favorites.find((element)=>{ return element === markitem.id; })}>
                <h2>{ markitem.surtitre }</h2>
                <h1>{ markitem.titre }</h1>
                <p>{ markitem.specs }<br/>{ markitem.country }</p>
              </Card>
            )})}
            </div>
        );
    }
}

const mapStateToProps = (state)=>{
    return {
      marks: state.marks.marks,
      favorites: state.marks.favorites
    }
  };

export default connect(mapStateToProps)(withRouter(MarksCards));
